import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {
  COLOR_BLACK,
  COLOR_ERROR,
  COLOR_GREY_1,
  COLOR_GREY_10,
  COLOR_GREY_11,
  COLOR_GREY_3,
  COLOR_GREY_5,
  COLOR_GREY_8,
  COLOR_PRIMARY_LIGHT,
  COLOR_PRIMARY_MAIN,
  COLOR_WHITE,
} from "shared/theme/colors";
import { border, flexCenter } from "shared/theme/mixins";

export const StyledPrimaryButton = styled(Button)`
  font-weight: 700;
  font-size: 1rem;
  text-transform: none;
  border-radius: 8px;
  padding: 0 1rem;
  min-width: 70px;
  align-items: center;
  color: ${COLOR_WHITE};
  white-space: nowrap;
  transition: all 0.3s ease;
  align-self: flex-end;

  &.small {
    height: 40px;

    &.rounded {
      border-radius: 8px;
    }
  }

  &.medium {
    height: 48px;

    &.rounded {
      border-radius: 8px;
    }
  }

  &.margin {
    margin: 0 1rem;
  }

  &.flex {
    flex: 1;
  }

  &.error {
    background-color: ${COLOR_ERROR};
  }

  &.contained {
    color: ${COLOR_WHITE};
    background-color: ${COLOR_PRIMARY_MAIN};
    transition: opacity 0.15s ease-in-out;

    :hover {
      opacity: 0.8;
      transition: opacity 0.15s ease-in-out;
    }

    &.error {
      background-color: ${COLOR_ERROR};
      box-shadow: none;

      :hover {
        background-color: ${COLOR_ERROR};
      }
    }

    &.secondary {
      color: ${COLOR_BLACK};
      background-color: ${COLOR_GREY_5};
    }

    :disabled,
    &.loading {
      color: ${COLOR_WHITE};
      background-color: ${COLOR_GREY_3};
      box-shadow: none;
    }
  }

  &.outlined {
    ${border()};
    color: ${COLOR_BLACK};

    :hover {
      background-color: ${COLOR_GREY_5};
    }

    &.error {
      color: ${COLOR_ERROR};

      :hover {
        background-color: ${COLOR_ERROR};
      }
    }

    &.secondary {
      color: ${COLOR_GREY_11};
      background-color: ${COLOR_GREY_1};
    }

    :disabled,
    &.loading {
      color: ${COLOR_GREY_10};
    }
  }

  &.text {
    min-width: auto;
    color: ${COLOR_PRIMARY_MAIN};

    &.error {
      color: ${COLOR_ERROR};

      :hover {
        background-color: ${COLOR_ERROR};
      }
    }

    &.exinity {
      color: ${COLOR_PRIMARY_LIGHT};
    }
  }

  &.text-no-effect {
    padding: 0;
    height: auto;
    min-width: auto;
    white-space: nowrap;

    :hover {
      background-color: transparent;
    }
  }

  &.shadow {
    color: ${COLOR_BLACK};
    white-space: nowrap;
    background-color: ${COLOR_WHITE};
    padding: 0 1rem;
    box-shadow:
      0 2px 2px rgba(0, 0, 0, 0.1),
      0 0 1px rgba(0, 0, 0, 0.15),
      0 8px 16px rgba(0, 0, 0, 0.15);
  }
`;

export const StyledLoadingContainer = styled(Box)`
  ${flexCenter()}
  width: 24px;
  height: 24px;

  .MuiCircularProgress-colorPrimary {
    color: ${COLOR_GREY_8};
  }
`;

export const StyledIconContainer = styled(Box)`
  display: flex;

  &:not(.left) {
    margin-left: 0.5rem;
  }

  &.left {
    margin-right: 0.5rem;
  }
`;
